// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".player-score {\n  align-items: center;\n  background-color: var(--riptide);\n  border-radius: 8px;\n  display: flex;\n  height: 48px;\n  margin-top: 12px;\n  min-width: 152px;\n  padding: 0 12px;\n  position: relative;\n}\n\n.player-1-3 {\n  height: 32px;\n  letter-spacing: 0;\n  text-align: left;\n  white-space: nowrap;\n}\n\n.player-score.player-score-1 {\n  margin-left: 10px;\n  margin-top: unset;\n}\n", ""]);
// Exports
module.exports = exports;
